<!--
  @Description: 收藏（新）
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div class="collect">
    <DataNavigation></DataNavigation>
    <div class="container">
      <div class="container-title">
        <div class="lf">我的收藏</div>
        <!-- <div class="rt">
          <span class="lk-btn">查看更多</span>
        </div> -->
      </div>
      <div class="container-filter">
        <div :class="{'on': active === ''}" @click="handleClickType('', '全部')">全部</div>
        <div :class="{'on': active === item.id}" v-for="item,index in typelist" :key="index" @click="handleClickType(item.id, item.name)">{{item.name}}</div>
      </div>
      <div class="list-container">
        <flow-list v-if="active === ''"></flow-list>
        <topic-list v-if="active === '0'"></topic-list>
        <report-list v-if="active === '1'"></report-list>
        <theme-list v-if="active === '2'"></theme-list>
        <policy-list v-if="active === '3'"></policy-list>
        <article-list v-if="active === '4'"></article-list>
        <report-image-list v-if="active === '9'"></report-image-list>
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <Modal class="message-model" title="提示" v-model="message_model" ok-text="确认" cancel-text="取消" @on-ok="cancelCollect(content_type, content_id, collectCb, cb_param, true)">
        <p>亲，取消收藏后，不再记录该信息，是否取消？</p>
      </Modal>
    </div>
  </div>
</template>
<script>
import DataNavigation from '@/components/DataNavigation'
import ArticleList from './components/ArticleList'
import TopicList from './components/TopicList'
import PolicyList from './components/PolicyList'
import ThemeList from './components/ThemeList'
import ReportList from './components/ReportList'
import ReportImageList from './components/ReportImageList'
import FlowList from './components/FlowList'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [collect_mixin],
  components: {
    DataNavigation,
    ArticleList,
    TopicList,
    PolicyList,
    ThemeList,
    ReportList,
    ReportImageList,
    FlowList,
  },
  created() {},
  mounted() {},
  data() {
    return {
      active: '',
      loading: true,
      message_model: false,
      typelist: [
        { id: '0', name: '快讯' },
        { id: '1', name: '报告' },
        { id: '2', name: '专题Pro' },
        { id: '4', name: '文章' },
        { id: '9', name: '数据图表' },
        { id: '3', name: '政策' },
      ],
      content_type: '',
      content_id: '',
      collectCb: '',
      cb_param: '',
    }
  },
  computed: {},
  methods: {
    handleClickType(t, name) {
      _czc.push(['_trackEvent', '我的收藏(新)', '标签切换(' + name + ')', '点击量'])
      this.loading = true
      this.active = t
    },
    goDetail(type, uid) {
      if (type == '0') {
        const href = this.$store.state.index2_path + '/newsDetail/' + uid
        window.open(href, '_blank')
      } else if (type == '1') {
        const { href } = this.$router.resolve({ name: 'ReportDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == '2') {
        const { href } = this.$router.resolve({ name: 'SpecialDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == '3') {
        const { href } = this.$router.resolve({ name: 'PolicyDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == '4') {
        const href = this.$store.state.index2_path + '/' + uid
        window.open(href, '_blank')
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.collect
  background #fff
  display flex
  justify-content center
  min-width 1200px
  >>> .ivu-spin
    color #FA5A00
  .container
    margin-left 20px
    width 1090px
    padding-bottom 40px
    .container-title
      padding 30px 0 20px
      display flex
      justify-content space-between
      .lf
        font-size 20px
        color #333333
        position relative
        line-height 1
        z-index 1
        &::before
          content ''
          position absolute
          background rgba(255, 186, 128, 1)
          height 6px
          width 100%
          bottom -3px
          z-index -1
      .rt
        .lk-btn
          color #FA5A00
          cursor pointer
    >>> .collect_share
      display flex
      font-size 12px
      color #999999
      align-items center
      .collec-icon
        margin-left 10px
        width 18px
        height 18px
        border-radius 2px
        font-size 10px
        background rgba(250, 122, 80, 1)
        color #ffffff
        display flex
        justify-content center
        align-items center
        cursor pointer
    >>> .commonlist
      .item
        &+.item
          margin-top 30px
        .dec
          margin-top 20px
          display flex
          justify-content space-between
          align-items center
        .title
          font-size 16px
          cursor pointer
          line-height 1
          span
            margin-right 21px
            position relative
            &:before
              content ''
              position absolute
              width 1px
              height 15px
              background #E9E9E9
              right -11px
              top 1px
          &:hover
            color rgba(250, 122, 80, 1)
            span:before
              background-color rgba(250, 122, 80, 1)
      .img-item
        display flex
        &+.img-item
          margin-top 30px
        .img, .img2
          position relative
          flex 0 0 242px
          height 152px
          cursor pointer
          .logo
            width 100%
            height 100%
            transition all 0.2s
          .u-li-type
            position absolute
            top 10px
            right -4px
        .img2
          background #EEEEEE
          display flex
          justify-content center
          align-items center
          .pic
            max-width 100%
            max-height 100%
        .info
          margin-left 20px
          position relative
          flex auto
        .title
          font-size 16px
          height 40px
          line-height 20px
          cursor pointer
          &:hover
            color rgba(250, 122, 80, 1)
        .summary
          margin-top 10px
          font-size 13px
          color #666
          height 40px
          line-height 20px
        .source
          margin-top 10px
          font-size 13px
          color #999
          height 40px
          line-height 20px
          display flex
          .report
            color #FA5A00
            // cursor pointer
        .dec
          display flex
          justify-content space-between
          margin-top 30px
    >>> .lt
      display flex
      align-items center
      .last-updata
        font-size 12px
        color #FA5A00
      .header-img
        width 24px
        height 24px
        border-radius 50%
      .span1
        margin-left 10px
        font-size 12px
      .info-item
        display flex
        align-items center
        font-size 12px
        color #666
        &+div
          margin-left 30px
        .iconfont
          font-size 12px
          color #999
          margin-right 6px
    .container-filter
      display flex
      flex-wrap wrap
      > div
        padding 0 15px
        height 24px
        background #FFFFFF
        border 1px solid #FA5A00
        border-radius 12px
        display flex
        justify-content center
        align-items center
        color #FA5A00
        cursor pointer
        &+div
          margin-left 20px
        &.on
          background #FA5A00
          color #fff
    .list-container
      margin-top 30px
      position relative
      min-height calc(100vh - 195px)
      .ivu-spin
        background #fff
        >>> .ivu-spin-main
          top 200px
      >>> .more-btn
        margin-top 40px
        display flex
        justify-content center
        > div
          width 136px
          height 40px
          background #FFFFFF
          border 1px solid #FA5A00
          border-radius 20px
          display flex
          justify-content center
          align-items center
          font-size 14px
          color #FA7A50
          cursor pointer
          transition all 0.2s
          &:hover
            background #FA5A00
            color #FFFFFF
      >>> .list-loading
        margin-top 40px
</style>